type Template = {
  subject: string,
  body: string,
};

type BillingTemplate = {
  billing: {
    inquiry: Template,
    changePlan: Template,
  }
}

type BillingPrefill = { template: Template, orgId?: string, userId?: string };

/** Stores multiple templates. Expand templates when there is more than 'billing' */
export const templates: BillingTemplate = {
  billing: {
    inquiry: {
      subject: 'Billing Inquiry',
      body: 'Please describe your question or issue:\n',
    },
    changePlan: {
      subject: 'Change Plan Request',
      body: '\n',
    },
  },
};

const billing = (prefill: BillingPrefill) => {
  if (!prefill) {
    return 'mailto:billing@fulcrumapp.com';
  }

  const { template, orgId, userId } = prefill;
  const urlParams = new URLSearchParams();

  let bodyContent = template.body;
  if (orgId) {
    bodyContent += `\nOrganization ID: [${orgId}]`;
  }
  if (userId) {
    bodyContent += `\nUser ID: [${userId}]`;
  }

  urlParams.append('subject', template.subject);
  urlParams.append('body', bodyContent);

  return `mailto:billing@fulcrumapp.com?${urlParams.toString().replace(/\+/g, '%20')}`;
};

/**
 * A simple object with external links to resources
 *
 * The format for naming links:
 *  - For top level links use "general" followed by the domain or resource
 *    - example: generalGroups
 *  - For resource level links use {resource}{shortened article title}
 *    - example: groupsSavingMembers
 */
const linkTo = {
  mail: {
    billing,
  },
  generalHelp: 'https://help.fulcrumapp.com/en/',
  groups: {
    generalHelp: 'https://help.fulcrumapp.com/en/articles/7436935-groups',
    removingAccess: 'https://help.fulcrumapp.com/en/articles/7436935-groups#h_0f681594a1',
  },
  recordDataView: (formID: string) => `https://${window.location.hostname}/dash/${formID}`,
  authorizations: {
    generalHelp: 'https://docs.fulcrumapp.com/reference/rest-api-intro',
  },
};

export default linkTo;
